export const RC_TYPES = {
  e2e: { label: 'E2E' },
  system_e2e: { label: 'System E2E' },
  performance: { label: 'Performance' },
};

// Marks `runId` as the `type` release candidate of its cycle (or clears it).
// At most one run per cycle holds each kind, so promoting removes that kind from the other runs.
export function setPromotedInRuns(runs, runId, type, promoted) {
  return runs.map(r => {
    const others = (r.promotedAs ?? []).filter(t => t !== type);
    const keep = r.id === runId ? promoted : false;
    return { ...r, promotedAs: keep ? [...others, type] : others };
  });
}

// Release candidates go on top; Array.prototype.sort is stable, so the rest keep their order.
export function promotedFirst(runs) {
  return [...runs].sort((a, b) => (b.promotedAs?.length ? 1 : 0) - (a.promotedAs?.length ? 1 : 0));
}

// A run can be a release candidate when its name carries an [E2E] or [SYS] tag (the backend decides the kind).
export function canPromote(run) {
  return /^\s*\[(E2E|SYS)\]/i.test(run.name ?? '');
}
